import React, { useState } from 'react';

interface HamburgerMenuProps {
  onAboutClick: () => void;
  onHistoryClick: () => void;
  dreamCount: number;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  onAboutClick,
  onHistoryClick,
  dreamCount,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleAboutClick = () => {
    onAboutClick();
    setIsOpen(false);
  };

  const handleHistoryClick = () => {
    onHistoryClick();
    setIsOpen(false);
  };

  return (
    <div className="hamburger-menu">
      <button
        className="hamburger-button"
        onClick={toggleMenu}
        aria-label="Menu"
        aria-expanded={isOpen}
      >
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
      </button>

      {isOpen && (
        <>
          <div className="menu-overlay" onClick={() => setIsOpen(false)} />
          <nav className="menu-panel">
            <button onClick={handleHistoryClick} className="menu-item">
              <div>
                <div className="menu-label">History</div>
                <div className="menu-sublabel">{dreamCount} saved</div>
              </div>
            </button>
            <button onClick={handleAboutClick} className="menu-item">
              <div>
                <div className="menu-label">About</div>
                <div className="menu-sublabel">Learn more</div>
              </div>
            </button>
          </nav>
        </>
      )}
    </div>
  );
};
